import React, { useMemo } from 'react'
import { ORDER_SERVICE_STATUS_COLUMNS } from '../../../utils/orderServiceStatus'
import { ItemOrderOfService } from '../ItemOrderOfService'
import styles from './orderServiceChecklist.module.css'

type Props = {
  orders: any[]
  orderOfServicesQtd?: Record<string, number>
  filterStatus: string
  onOpenDetails: (order: any) => void
  refresh: () => void
  setShowModalDelete: (v: boolean) => void
  setMyOrderService: (v: any) => void
  setShowCreateAppModal: (v: boolean) => void
  setShowModalTemplate: (v: boolean) => void
}

/** Colunas por status; cards com todas as ações do ItemOrderOfService. */
export function OrderServiceChecklistBoard({
  orders,
  orderOfServicesQtd,
  filterStatus,
  onOpenDetails,
  refresh,
  setShowModalDelete,
  setMyOrderService,
  setShowCreateAppModal,
  setShowModalTemplate,
}: Props) {
  const columns = useMemo(() => {
    if (filterStatus) {
      return ORDER_SERVICE_STATUS_COLUMNS.filter((c) => c.key === filterStatus)
    }
    return ORDER_SERVICE_STATUS_COLUMNS
  }, [filterStatus])

  const grouped = useMemo(() => {
    const map: Record<string, any[]> = {}
    ORDER_SERVICE_STATUS_COLUMNS.forEach((c) => {
      map[c.key] = []
    })
    orders?.forEach((order) => {
      const status = order?.status
      const key = status && map[status] !== undefined ? status : 'AGUARDANDO'
      map[key].push(order)
    })
    return map
  }, [orders])

  const getCount = (qtdKey: string, statusKey: string) => {
    if (orderOfServicesQtd && qtdKey in orderOfServicesQtd) {
      return (orderOfServicesQtd as Record<string, number>)[qtdKey] ?? 0
    }
    return grouped[statusKey]?.length ?? 0
  }

  const itemProps = {
    refresh,
    setShowModalDelete,
    setMyOrderService,
    setShowCreateAppModal,
    setShowModalTemplate,
    onOpenDetails,
    layoutMode: 'checklist' as const,
  }

  const isSingleColumn = columns.length === 1

  return (
    <div className={`${styles.board} ${isSingleColumn ? styles.boardSingle : ''}`}>
      {columns.map((column) => (
        <section
          key={column.key}
          className={`${styles.column} ${filterStatus ? styles.columnSingle : ''}`}
        >
          <header
            className={`${styles.columnHeader} ${styles[`header--${column.accent}`]}`}
          >
            <span>{column.label}</span>
            <span className={styles.columnCount}>
              {getCount(column.qtdKey, column.key)}
            </span>
          </header>
          <ul className={styles.checklist}>
            {grouped[column.key]?.length > 0 ? (
              grouped[column.key].map((order) => (
                <li
                  key={order.id}
                  className={styles.checklistItem}
                  onClick={() => onOpenDetails(order)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault()
                      onOpenDetails(order)
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <ItemOrderOfService itemOrderOfService={order} {...itemProps} />
                </li>
              ))
            ) : (
              <li className={styles.empty}>Nenhuma O.S. neste status</li>
            )}
          </ul>
        </section>
      ))}
    </div>
  )
}
